var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',{staticClass:"mt-6",attrs:{"disabled":!_vm.input.isEdit,"label":_vm.item.Attachment ? _vm.item.Attachment.Name : 'добавит файл',"outlined":"","dense":""},on:{"change":_vm.file}})}
var staticRenderFns = []

export { render, staticRenderFns }